import { money } from "@/lib/format";

function Row({ label, value, strong, testId }) {
  return (
    <div className={`flex justify-between py-1.5 ${strong ? "text-base font-semibold text-slate-900" : "text-sm text-slate-600"}`}>
      <span>{label}</span><span data-testid={testId}>{value}</span>
    </div>
  );
}

export default function DocView({ doc }) {
  const isInvoice = doc.amount_paid !== undefined;
  return (
    <div data-testid="doc-view">
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-xs uppercase tracking-wider text-slate-500 border-b border-slate-200">
              <th className="py-2 pr-2 font-medium">Description</th>
              <th className="py-2 px-2 font-medium text-right">Qty</th>
              <th className="py-2 px-2 font-medium text-right">Price</th>
              <th className="py-2 pl-2 font-medium text-right">Amount</th>
            </tr>
          </thead>
          <tbody>
            {doc.items.map((i, idx) => (
              <tr key={idx} className="border-b border-slate-100" data-testid={`doc-item-${idx}`}>
                <td className="py-3 pr-2 text-slate-900">{i.description}{i.category === "addon" && <span className="ml-2 text-xs text-teal-700">Add-on</span>}</td>
                <td className="py-3 px-2 text-right">{i.quantity}</td>
                <td className="py-3 px-2 text-right">{money(i.unit_price)}</td>
                <td className="py-3 pl-2 text-right font-medium text-slate-900">{money(i.amount)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="ml-auto max-w-xs mt-4">
        <Row label="Subtotal" value={money(doc.subtotal)} testId="doc-subtotal" />
        {doc.discount_amount > 0 && <Row label={`Discount${doc.discount_type === "percent" ? ` (${doc.discount_value}%)` : ""}`} value={`−${money(doc.discount_amount)}`} testId="doc-discount" />}
        {doc.tax_rate > 0 && <Row label={`Tax (${doc.tax_rate}%)`} value={money(doc.tax_amount)} testId="doc-tax" />}
        <div className="border-t border-slate-200 mt-1 pt-1"><Row label="Total" value={money(doc.total)} strong testId="doc-total" /></div>
        {isInvoice && <Row label="Paid" value={money(doc.amount_paid)} testId="doc-paid" />}
        {isInvoice && <Row label="Balance due" value={money(doc.balance)} strong testId="doc-balance" />}
      </div>
      {doc.notes && <p className="text-sm text-slate-600 mt-6 whitespace-pre-wrap" data-testid="doc-notes">{doc.notes}</p>}
    </div>
  );
}
